import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Copy = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <g transform="translate(2 2)">
        <path d="M7.2 6.4a.756.756 0 0 1 .8-.8h6.4V.8a.756.756 0 0 0-.8-.8h-12a.756.756 0 0 0-.8.8v14.4a.756.756 0 0 0 .8.8h5.6z" />
        <path d="M17.6 7.2h-8a.756.756 0 0 0-.8.8v10.4a.756.756 0 0 0 .8.8h8a.756.756 0 0 0 .8-.8V8a.756.756 0 0 0-.8-.8z" />
      </g>
    </svg>
  );
};

Copy.displayName = 'Copy';
